import React from 'react';
import { Button } from '../ui/button';
import { Input } from '../ui/input';
import { Label } from '../ui/label';
import { Dialog, DialogContent, DialogDescription, DialogHeader, DialogTitle } from '../ui/dialog';

const EditCommissionDialog = ({ editDialog, setEditDialog, editPct, setEditPct, saveEdit }) => {
  return (
    <Dialog open={!!editDialog} onOpenChange={v => { if (!v) setEditDialog(null); }}>
      <DialogContent className="max-w-md z-50">
        <DialogHeader><DialogTitle>{editDialog?.type === 'bill' ? 'Edit Bill Override' : 'Edit Customer/Distributor Rates'}</DialogTitle>
          <DialogDescription>{editDialog?.type === 'bill' ? `Override for ${editDialog?.name}` : `Default rates for ${editDialog?.name}`}</DialogDescription>
        </DialogHeader>
        <div className="space-y-4 pt-2">
          {editDialog?.is_frozen && (
            <div className="p-2 bg-blue-50 border border-blue-200 rounded text-xs text-blue-700" data-testid="frozen-notice">
              <b>Paid bill — values are frozen at payment time.</b> Mark Unpaid first if you want to change them.
            </div>
          )}
          <div className="grid grid-cols-2 gap-3">
            <div><Label className="text-xs font-semibold">Commission %</Label>
              <Input type="number" step="0.5" min="0" max="100" value={editPct} onChange={e => setEditPct(e.target.value)} autoFocus
                data-testid="edit-commission-input" onKeyDown={e => { if (e.key === 'Enter') saveEdit(); }}
                disabled={editDialog?.is_frozen} />
            </div>
            <div><Label className="text-xs font-semibold">Discount %</Label>
              <Input type="number" step="0.5" min="0" max="100"
                value={editDialog?.discount_pct || 0}
                onChange={e => setEditDialog(prev => ({ ...prev, discount_pct: e.target.value }))}
                data-testid="edit-discount-pct-input"
                disabled={editDialog?.is_frozen} />
            </div>
          </div>
          {editDialog?.type === 'bill' && (
            <>
              <div><Label className="text-xs font-semibold">2nd Commission % (optional, on remainder after 1st)</Label>
                <Input type="number" step="0.5" min="0" max="100"
                  value={editDialog?.pct_2 ?? ''}
                  onChange={e => setEditDialog(prev => ({ ...prev, pct_2: e.target.value }))}
                  placeholder="Blank = use agent default"
                  data-testid="edit-commission-pct2-input"
                  disabled={editDialog?.is_frozen} />
                <p className="text-[10px] text-gray-500 mt-1">Blank clears the per-bill override (inherits agent's default 2nd %). Enter 0 to force no 2nd commission.</p>
              </div>
              <div><Label className="text-xs font-semibold">Discount Amount (flat, overrides %)</Label>
                <Input type="number" step="1" min="0"
                  value={editDialog?.discount_amount || ''}
                  onChange={e => setEditDialog(prev => ({ ...prev, discount_amount: e.target.value }))}
                  placeholder="Leave empty to use % above"
                  data-testid="edit-discount-amount-input"
                  disabled={editDialog?.is_frozen} />
              </div>
              <div className="p-3 bg-amber-50 rounded-lg border border-amber-200">
                <Label className="text-xs font-semibold text-amber-800">Manual Commission Override (replaces calculation)</Label>
                <Input type="number" step="1" min="0"
                  value={editDialog?.manual_commission ?? ''}
                  onChange={e => setEditDialog(prev => ({ ...prev, manual_commission: e.target.value }))}
                  placeholder="Leave empty for auto-calculation"
                  data-testid="edit-manual-commission-input"
                  disabled={editDialog?.is_frozen} />
                <p className="text-[10px] text-amber-600 mt-1">If set, this flat amount will be used instead of % calculation</p>
              </div>
            </>
          )}
          <div className="flex gap-2 justify-end">
            <Button variant="outline" onClick={() => setEditDialog(null)}>Cancel</Button>
            <Button className="bg-indigo-600 hover:bg-indigo-700" onClick={saveEdit} data-testid="save-commission-btn" disabled={editDialog?.is_frozen}>Save</Button>
          </div>
        </div>
      </DialogContent>
    </Dialog>
  );
};

export default EditCommissionDialog;
